module.exports = __webpack_public_path__ + "static/media/object-ungroup.09d6c5a7.svg";